import { Component, OnInit } from '@angular/core';
import { NotificationService } from './notification.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  isLoading: boolean = false;
  filter: string = "all";
  notiArr = [];
  rows = [];
  dates = new Date();
  page: number = 1;
  pageSize: number = 30;
  collectionSize: number;

  constructor(
    private notificationService: NotificationService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.gobalFunctionService.setTitle('Notification');
    this.getNotiByType();
  }

  getNotiByType() {
    this.isLoading = true;
    this.notiArr = [];
    this.rows = [];
    this.page = 1;

    switch (this.filter) {
      case 'all': {
        // // console.log('all');
        this.notificationService.getAllNotificationByUser().subscribe(res => {
          this.isLoading = false;
          this.notiArr = res.result.reverse();
          this.refresh();
        })
        break;
      }
      case 'read': {
        // // console.log('read');
        this.notificationService.getAllNotiByType(1).subscribe(res => {
          this.isLoading = false;
          this.notiArr = res.result.reverse();
          this.refresh();
        })
        break;
      }

      case 'unread': {
        // // console.log('unread');
        this.notificationService.getAllNotiByType(0).subscribe(res => {
          this.isLoading = false;
          this.notiArr = res.result.reverse();
          this.refresh();
        })
        break;
      }
    }
  }

  getLength(arr) {
    return arr.length;
  }

  updateStatusNoti(noti) {
    let body = { ID: [noti.ID] };

    if (noti.NOTI_STATUS === 0) {
      // ยังไม่ได้อ่าน
      this.notificationService.updateStatusNoti(body).subscribe(() => {
        if (noti.LINK)
          window.open(noti.LINK, "_self");
        else
          location.reload();
        // this.getNotiByType();
      });
    } else {
      // อ่านแล้ว
      if (noti.LINK)
        window.open(noti.LINK, "_self");
    }
  }

  readAll() {
    let body = { ID: [] };

    this.notiArr.map(res => {
      body.ID.push(res.ID);
    })

    if (body.ID.length > 0) {
      this.notificationService.updateStatusNoti(body).subscribe(() => {
        // this.getNotiByType();
        location.reload();
      });
    }
  }

  refresh() {
    this.collectionSize = this.notiArr.length;
    this.rows = this.notiArr
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
}
